import {useEffect, useState} from "react"
/**
 * useTimer: 指定された時間ごとにアップデートされるタイマーの値を返す
 * @param {number} initialValue タイマーの初期値
 * @param {number} interval タイマーがインクリメントされる間隔
 * @returns {number} 現在のタイマーの値
 */
export default function useTimer(initialValue, interval) {
  const [count, setCount] = useState(initialValue)
  useEffect(() => {
    setTimeout(setCount.bind(null, count + 1), interval)
  })
  return count
}
